/**
 * Pick a gallery photo for each layanan item from album/title theme.
 * Themes: Produksi, RnD/Lab, Marketing, Office.
 */
const textOf = (v) => {
  if (!v) return "";
  if (typeof v === "string") return v;
  return `${v.id || ""} ${v.en || ""}`;
};

export const serviceTheme = (item) => {
  const hay = `${textOf(item.title)} ${textOf(item.desc)}`.toLowerCase();
  if (/(riset|pengembangan|\br&d\b|research|development)/.test(hay)) return "rnd";
  if (/(legalitas|sertifikasi|\blegal\b|certification)/.test(hay)) return "legal";
  if (/private\s*label/.test(hay)) return "private";
  if (/\boem\b|\bodm\b/.test(hay)) return "oem";
  if (/contract/.test(hay)) return "contract";
  return "maklon";
};

const score = (g, theme) => {
  const album = `${g.album || ""}`.toLowerCase();
  const title = `${g.title || ""}`.toLowerCase();
  const prefer = {
    rnd: { albums: ["rnd"], titles: ["lab"] },
    legal: { albums: ["staff"], titles: ["office"] },
    private: { albums: ["staff"], titles: ["marketing"] },
    oem: { albums: ["rnd"], titles: ["lab"] },
    contract: { albums: ["produksi"], titles: ["produksi"] },
    maklon: { albums: ["produksi"], titles: ["produksi"] },
  }[theme] || { albums: [], titles: [] };

  let n = 0;
  if (prefer.albums.some((a) => album.includes(a))) n += 10;
  if (prefer.titles.some((t) => title.includes(t))) n += 8;
  if (theme === "legal" && title.includes("welcome")) n += 4;
  if (theme === "private" && title.includes("gbj")) n += 3;
  if (theme === "maklon" && /produksi\s*17/.test(title)) n += 12;
  return n;
};

/** Assign unused gallery photos to layanan items by theme. */
export const matchGalleryToServices = (items = [], gallery = []) => {
  const used = new Set();
  return items.map((item) => {
    if (item.galleryId) {
      const locked = gallery.find((g) => g.id === item.galleryId);
      if (locked) {
        used.add(locked.id);
        return locked;
      }
    }
    const theme = serviceTheme(item);
    const ranked = gallery
      .filter((g) => !used.has(g.id))
      .map((g) => ({ g, n: score(g, theme) }))
      .filter((x) => x.n > 0)
      .sort((a, b) => b.n - a.n || Number(a.g.order || 0) - Number(b.g.order || 0));
    const pick = ranked[0]?.g || null;
    if (pick) used.add(pick.id);
    return pick;
  });
};
